import React from 'react'
import Avatar from 'avataaars'

export default [
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='WinterHat3'
    accessoriesType='Blank'
    hatColor='White'
    facialHairType='BeardMedium'
    facialHairColor='BrownDark'
    clotheType='CollarSweater'
    clotheColor='PastelGreen'
    eyeType='Squint'
    eyebrowType='DefaultNatural'
    mouthType='Default'
    skinColor='Brown'
  />,
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='LongHairNotTooLong'
    accessoriesType='Blank'
    hairColor='Blonde'
    facialHairType='MoustacheMagnum'
    facialHairColor='Black'
    clotheType='BlazerShirt'
    eyeType='Wink'
    eyebrowType='UpDownNatural'
    mouthType='Eating'
    skinColor='Pale'
  />,
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='ShortHairDreads01'
    accessoriesType='Blank'
    hairColor='BlondeGolden'
    facialHairType='BeardMedium'
    facialHairColor='Red'
    clotheType='Overall'
    clotheColor='Gray02'
    eyeType='Surprised'
    eyebrowType='UpDownNatural'
    mouthType='Vomit'
    skinColor='DarkBrown'
  />,
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='NoHair'
    accessoriesType='Blank'
    facialHairType='MoustacheFancy'
    facialHairColor='Auburn'
    clotheType='BlazerShirt'
    eyeType='Squint'
    eyebrowType='UnibrowNatural'
    mouthType='Serious'
    skinColor='Pale'
  />,
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='ShortHairTheCaesarSidePart'
    accessoriesType='Round'
    hairColor='Brown'
    facialHairType='MoustacheFancy'
    facialHairColor='Black'
    clotheType='GraphicShirt'
    clotheColor='PastelOrange'
    graphicType='SkullOutline'
    eyeType='Wink'
    eyebrowType='SadConcernedNatural'
    mouthType='Smile'
    skinColor='Yellow'
  />,
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='Hijab'
    accessoriesType='Kurt'
    hatColor='PastelBlue'
    clotheType='ShirtScoopNeck'
    clotheColor='Gray02'
    eyeType='Close'
    eyebrowType='UpDown'
    mouthType='Twinkle'
    skinColor='Yellow'
  />,
  (x) => <Avatar {...x}
    avatarStyle='Circle'
    topType='LongHairCurvy'
    accessoriesType='Blank'
    hairColor='Red'
    facialHairType='BeardMedium'
    facialHairColor='Black'
    clotheType='ShirtVNeck'
    clotheColor='Heather'
    eyeType='Dizzy'
    eyebrowType='DefaultNatural'
    mouthType='Concerned'
    skinColor='Light'
  />
]